import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as SaRaActions from './sa-ra.actions';
import { initialState } from './sa-ra.state';
export const SaRaFeatureKey = 'SARA';

export const reducer = createReducer(
  initialState,
  on(SaRaActions.loadRaTemplateSuccess, (state, { raTemplate }) => ({
    ...state,
    raTemplate,
  })),
  on(SaRaActions.loadLikelihoodSuccess, (state, { likelihood }) => ({
    ...state,
    likelihood,
  })),
  on(SaRaActions.addLikelihoodSuccess, (state, action) => {
    const updatedState = {
      ...state,
      likelihood: [...state.likelihood, action.likelihood],
    };
    return updatedState;
  }),
  on(SaRaActions.updateLikelihoodSuccess, (state, action) => {
    const ulk = state.likelihood.map((lk) =>
      lk.id == action.likelihood.id ? action.likelihood : lk
    );
    const updatedState = {
      ...state,
      likelihood: ulk,
    };
    return updatedState;
  }),
  on(SaRaActions.deleteLikelihoodSuccess, (state, action) => {
    return {
      ...state,
      likelihood: state.likelihood.filter(
        (lk) => lk.id !== action.likelihood.id
      ),
    };
  }),
  on(SaRaActions.loadImpactRatingSuccess, (state, { impactRating }) => ({
    ...state,
    impactRating,
  })),
  on(SaRaActions.addImpactRatingSuccess, (state, action) => {
    const updatedState = {
      ...state,
      impactRating: [...state.impactRating, action.impactRating],
    };
    return updatedState;
  }),
  on(SaRaActions.updateImpactRatingSuccess, (state, action) => {
    const uir = state.impactRating.map((ir) =>
      ir.id == action.impactRating.id ? action.impactRating : ir
    );
    const updatedState = {
      ...state,
      impactRating: uir,
    };
    return updatedState;
  }),
  on(SaRaActions.deleteImpactRatingSuccess, (state, action) => {
    return {
      ...state,
      impactRating: state.impactRating.filter(
        (ir) => ir.id !== action.impactRating.id
      ),
    };
  }),
  on(SaRaActions.loadRiskRatingSuccess, (state, { riskRating }) => ({
    ...state,
    riskRating,
  })),
  on(SaRaActions.addRiskRatingSuccess, (state, action) => {
    const updatedState = {
      ...state,
      riskRating: [...state.riskRating, action.riskRating],
    };
    return updatedState;
  }),
  on(SaRaActions.updateRiskRatingSuccess, (state, action) => {
    const urr = state.riskRating.map((rr) =>
      rr.id == action.riskRating.id ? action.riskRating : rr
    );
    const updatedState = {
      ...state,
      riskRating: urr,
    };
    return updatedState;
  }),
  on(SaRaActions.deleteRiskRatingSuccess, (state, action) => {
    return {
      ...state,
      riskRating: state.riskRating.filter(
        (rr) => rr.id !== action.riskRating.id
      ),
    };
  }),
  on(SaRaActions.loadVulnerabilitiesSuccess, (state, { vulnerabilities }) => ({
    ...state,
    vulnerabilities,
  })),
  on(SaRaActions.addVulnerabilitiesSuccess, (state, action) => {
    const updatedState = {
      ...state,
      vulnerabilities: [...state.vulnerabilities, action.vulnerabilities],
    };
    return updatedState;
  }),
  on(SaRaActions.updateVulnerabilitiesSuccess, (state, action) => {
    const uvd = state.vulnerabilities.map((vd) =>
      vd.id == action.vulnerabilities.id ? action.vulnerabilities : vd
    );
    const updatedState = {
      ...state,
      vulnerabilities: uvd,
    };
    return updatedState;
  }),
  on(SaRaActions.deleteVulnerabilitiesSuccess, (state, action) => {
    return {
      ...state,
      vulnerabilities: state.vulnerabilities.filter(
        (vd) => vd.id !== action.vulnerabilities.id
      ),
    };
  }),
  on(SaRaActions.loadRiskVelocitySuccess, (state, { riskVelocity }) => ({
    ...state,
    riskVelocity,
  })),
  on(SaRaActions.addRiskVelocitySuccess, (state, action) => {
    const updatedState = {
      ...state,
      riskVelocity: [...state.riskVelocity, action.riskVelocity],
    };
    return updatedState;
  }),
  on(SaRaActions.updateRiskVelocitySuccess, (state, action) => {
    const urv = state.riskVelocity.map((rv) =>
      rv.id == action.riskVelocity.id ? action.riskVelocity : rv
    );
    const updatedState = {
      ...state,
      riskVelocity: urv,
    };
    return updatedState;
  }),
  on(SaRaActions.deleteRiskVelocitySuccess, (state, action) => {
    return {
      ...state,
      riskVelocity: state.riskVelocity.filter(
        (rv) => rv.id !== action.riskVelocity.id
      ),
    };
  })
);
